<script setup>
import { computed } from 'vue';
import { RouterLink } from 'vue-router';
import CoveragePolicyCard from './CoveragePolicyCard.vue';
import { bySoonestRenewal } from '../../helpers/coverage';

/**
 * Home's Your insurance (XN-4734): My coverage's own cards, up to two (one
 * row, as the prototype has it; XN-4736), soonest renewal first, each saying
 * how far off its renewal is. Absent with no active policy; the rest are a tap
 * away in My coverage.
 */
const props = defineProps({
  policies: { type: Array, required: true },
  now: { type: Date, required: true },
});
const MAX_CARDS = 2;
const cards = computed(() => bySoonestRenewal(props.policies, props.now).slice(0, MAX_CARDS));
</script>

<template>
  <section v-if="cards.length" class="ins" data-testid="home-insurance">
    <div class="ins__sh">
      <h2>Your insurance</h2>
      <span class="ins__ln" />
      <RouterLink to="/hub/coverage" class="ins__all">See everything</RouterLink>
    </div>
    <div class="ins__grid">
      <CoveragePolicyCard v-for="policy in cards" :key="policy.id" :policy="policy" :now="now" detail />
    </div>
  </section>
</template>

<style scoped>
/* Section header as Coming up's: prototype `.sh`, 34px above. */
.ins__sh { display: flex; align-items: center; gap: 12px; margin: 34px 0 14px; }
.ins__sh h2 { margin: 0; font-size: 13px; font-weight: 600; letter-spacing: 0.1em; text-transform: uppercase; color: var(--xl-color-outline-variant); }
.ins__ln { flex: 1; height: 1px; background: var(--xl-color-border); }
.ins__all { font-size: 13.5px; font-weight: 600; color: var(--xl-color-primary); text-decoration: none; }
.ins__grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 14px; }
@media (max-width: 700px) { .ins__grid { grid-template-columns: 1fr; } }
</style>
